import Place from '@components/fields/Place'

import styles from './styles.module.css'

export interface Props {
  title: string
  placeId: string
  setPlaceId: (placeId: string) => void
}

export default function Top(props: Props) {
  const {placeId, setPlaceId} = props
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <h1>Selecciona un local</h1>
      </div>
      <p className={styles.description}>
        Ingresa tu dirección para mostrarte los locales más cercanos
      </p>
      <Place placeholder="Dirección" value={placeId} onChange={setPlaceId} />
    </div>
  )
}
